import { ZonedDateTime } from '@js-joda/core';
import { RangeType } from 'rsuite/esm/DateRangePicker';
import {
  getLocalTimeUtcEndOfDay,
  getLocalTimeUtcStartOfDay,
} from '../../../utils/date';
import { EventLabels } from '../../../utils/trackingEvents';

const startOfToday = getLocalTimeUtcStartOfDay();
const endOfToday = getLocalTimeUtcEndOfDay();
const zdtToJsDate = (zdt: ZonedDateTime) =>
  new Date(zdt.withFixedOffsetZone().toJSON());

export type RangeTypeWithEventLabel = RangeType & {
  eventlabel: EventLabels;
};

export const defaultPredefinedRanges: RangeTypeWithEventLabel[] = [
  {
    eventlabel: EventLabels.Last45days,
    label: 'Last 45 Days',
    value: [zdtToJsDate(startOfToday.minusDays(45)), zdtToJsDate(endOfToday)],
    placement: 'left',
  },
  {
    eventlabel: EventLabels.Last7days,
    label: 'Last 7 Days',
    value: [zdtToJsDate(startOfToday.minusDays(7)), zdtToJsDate(endOfToday)],
    placement: 'left',
  },
  {
    eventlabel: EventLabels.Today,
    label: 'Today',
    value: [zdtToJsDate(startOfToday), zdtToJsDate(endOfToday)],
    placement: 'left',
  },
  {
    eventlabel: EventLabels.Next7days,
    label: 'Next 7 Days',
    value: [zdtToJsDate(startOfToday), zdtToJsDate(endOfToday.plusDays(7))],
    placement: 'left',
  },
  {
    eventlabel: EventLabels.Next45days,
    label: 'Next 45 Days',
    value: [zdtToJsDate(startOfToday), zdtToJsDate(endOfToday.plusDays(45))],
    placement: 'left',
  },
];

export const sleepTrendPredefinedRanges: RangeTypeWithEventLabel[] = [
  {
    eventlabel: EventLabels.Last45days,
    label: 'Last 28 Days',
    value: [
      zdtToJsDate(startOfToday.minusDays(28)),
      zdtToJsDate(endOfToday.minusDays(1)),
    ],
    placement: 'left',
  },
  {
    eventlabel: EventLabels.Last45days,
    label: 'Last 14 Days',
    value: [
      zdtToJsDate(startOfToday.minusDays(14)),
      zdtToJsDate(endOfToday.minusDays(1)),
    ],
    placement: 'left',
  },
  {
    eventlabel: EventLabels.Last7days,
    label: 'Last 7 Days',
    value: [
      zdtToJsDate(startOfToday.minusDays(7)),
      zdtToJsDate(endOfToday.minusDays(1)),
    ],
    placement: 'left',
  },
];
